import React from 'react'

const About = () => {
    return <section id='about' className='about-area'></section>
}

export default About
